import AudioInputChooser from 'components/AudioInputChooser.js';
import React, { Component } from 'react';

class SampleSource extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 'youtube'
        };
        this.setState(this.state);
    }

    handleOptionChange(e) {
        if (e.target.value === 'youtube') {
            this.state.type = 'youtube';
        } else {
            this.state.type = 'vinyl';
        }
        this.props.onSampleSourceChange(this.state.type);
        this.setState(this.state);
    }

    render() {
        return (
            <div className="sample-source">
            <form>
              <div className="radio">
                <label>
                  <input className="filter-radio"
                         type="radio"
                         value="youtube"
                         checked={this.state.type === 'youtube'}
                         onChange={(e) => this.handleOptionChange(e)} />
                   Youtube 
                </label>
                <label>
                  <input className="filter-radio"
                         type="radio"
                         value="vinyl"
                         checked={this.state.type === 'vinyl'}
                         onChange={(e) => this.handleOptionChange(e)} />
                    Vinyl
                </label>
                <AudioInputChooser
                  defaultInput="Soundflower (2ch)"
                  deviceId={this.props.deviceId}
                  onChooseAudio={(x, deviceId) => this.props.onChooseAudio(x, deviceId)}/>
              </div>
            </form>
        </div>);
    }
}

export default SampleSource;
